module.exports = __webpack_public_path__ + "static/media/banner_mclaren.0b08b87e.png";